<form [formGroup]="ticketFormGroup">
  <table>
    <tbody>
      <tr>
        <td>
          <p class="section-label">
            {{ 'common.bukTicketFormComponent.titles.count' | translate }}
          </p>
        </td>
        <td>
          <mat-form-field
            class="full-width no-placeholder"
            appearance="outline"
          >
            <input
              required
              matInput
              formControlName="count"
              type="number"
              placeholder="{{
                'common.bukTicketFormComponent.placeholder.count' | translate
              }}"
            />
            <mat-hint>
              {{
                'common.bukTicketFormComponent.messages.countRangeHint'
                  | translate
              }}
            </mat-hint>
            <mat-error
              *ngIf="ticketFormGroup.get('count').hasError('required')"
              >{{
                'common.bukTicketFormComponent.messages.onlyNumber' | translate
              }}</mat-error
            >
            <mat-error *ngIf="ticketFormGroup.get('count').hasError('max')">{{
              'common.bukTicketFormComponent.messages.countRangeError'
                | translate
            }}</mat-error>
            <mat-error
              *ngIf="
                ticketFormGroup.get('count').hasError('notEnoughCreditsError')
              "
              >{{
                'common.bukTicketFormComponent.messages.chargePermissionDenied'
                  | translate
              }}</mat-error
            >
          </mat-form-field>
        </td>
      </tr>
      <tr *ngIf="!_isUnlimitedTicket">
        <td class="center">
          <p class="section-label">
            {{ 'common.bukTicketFormComponent.titles.expiryDate' | translate }}
          </p>
        </td>
        <td class="center">
          <div class="expiry-date-field-wrapper">
            <mat-form-field class="select">
              <mat-select
                formControlName="expiryDate"
                (selectionChange)="isDatePickerMode = false"
              >
                <mat-option
                  *ngFor="let expiryDate of expiryDates"
                  [value]="expiryDate"
                  >{{ expiryDate | periodTranslate }}</mat-option
                >
                <mat-option (click)="openDatePicker()">
                  {{
                    'common.bukTicketFormComponent.titles.datepicker'
                      | translate
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              class="datepicker"
              [class.hidden]="!isDatePickerMode"
            >
              <input
                matInput
                [matDatepicker]="picker"
                (dateChange)="updateExpiryDate($event.value)"
              />
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        </td>
      </tr>
      <tr *ngIf="!_isUnlimitedTicket">
        <td class="center">
          <p class="section-label">
            {{ 'common.bukTicketFormComponent.titles.period' | translate }}
          </p>
        </td>
        <td class="center">
          <mat-form-field class="select">
            <mat-select formControlName="period">
              <mat-option *ngFor="let period of periods" [value]="period">{{
                period | periodTranslate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </tr>
    </tbody>
  </table>
</form>
